import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import _ from 'lodash';

export interface DataListItem {
  label: string;
  value: string | string[];
  cssClass?: string;
  alias?: string;
  metadata?: {
    extraLabel?: string;
    cssClass?: string;
    pipe?: string;
    link?: string;
    icon?: {
      id: string;
      color: string;
      tooltip: string;
    };
    countryCode?: any;
    phoneCountryCode?: any;
  };
}

@Component({
  selector: 'app-data-list',
  templateUrl: './data-list.component.html',
  styleUrls: ['./data-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DataListComponent {

  @Input() dataList: DataListItem[];
  @Input() title: string;
  @Input() toggleTitle: string;
  @Input() displayLimit: number;
  @Input() loading: boolean;
  @Output() editClicked = new EventEmitter();
  moreDetailsOpen: boolean = false;

  constructor(public dialog: MatDialog) {}

  get dataListHead(): DataListItem[] {
    if (this.dataList) {
      this.dataList = this.dataList.filter(item => !item.label.includes('Phone Country Code Id'));
    }
    return this.dataList ? this.dataList.slice(0, this.displayLimit) : [];
  }

  get dataListTail(): DataListItem[] {
    return this.dataList ? this.dataList.slice(this.displayLimit) : [];
  }

  checkIfArray(data): boolean {
    return !!data && Array.isArray(data);
  }

  checkIfLongText(value): boolean {
    if (value === null || typeof value !== 'string') {
      return false;
    }
    return value.length > 25;
  }

  getAttributeName(label): string {
    return `dl-bv-${_.kebabCase(label)}`;
  }

  onEditClicked() {
    this.editClicked.emit();
  }
}

@Component({
  selector: 'app-data-list-simple',
  templateUrl: './data-list-basic.component.html',
  styleUrls: ['./data-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DataListBasicComponent extends DataListComponent {}
